import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Arrow-Down2",
  "use": "icon-Arrow-Down2-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-Arrow-Down2\">\r\n<path d=\"M7 8.16638L3.5 4.66638L10.5 4.66638L7 8.16638Z\" fill=\"#4F4F4F\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol